module.exports = __webpack_public_path__ + "static/img/NEEWER_Control-app-icon-optimized-9b9ab116-d204-4754-b3ac-fc8876f57c6a.d5bd978e.png";